import { Loader } from '../loader'

import c from './content-loader.module.scss'

export const ContentLoader = () => (
    <div className={c.component}>
        <Loader />
    </div>
)
